import { GeoFormModel } from './types';

export const GEO_FORM_MODEL_DEFAULT_VALUES: GeoFormModel = {
  administrativeAreaLevelOne: '',
  administrativeAreaLevelTwo: '',
  locality: '',
  plateCode: '',
  postalCode: '',
  route: '',
  suburb: '',
  streetNumber: '',
  latitude: '',
  longitude: '',
  normalizedAddress: null,
};
